import { Exchange } from '../types/exchange';

const EODHD_API_KEY = process.env.REACT_APP_EODHD_API_TOKEN;
const EODHD_BASE_URL = 'https://eodhd.com/api';

export interface ExchangeResponse {
  Code: string;
  Name: string;
  OperatingMIC: string;
  Country: string;
  Currency: string;
  CountryISO2: string;
  CountryISO3: string;
  TradingHours?: {
    Open: string;
    Close: string;
    Timezone: string;
  };
  Holidays?: {
    Date: string;
    Name: string;
  }[];
}

export const getExchanges = async (): Promise<Exchange[]> => {
  try {
    const response = await fetch(
      `${EODHD_BASE_URL}/exchanges-list?api_token=${EODHD_API_KEY}&fmt=json`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch exchanges');
    }

    const data: ExchangeResponse[] = await response.json();
    
    // Transform the response to match our Exchange type
    return data.map(exchange => ({
      code: exchange.Code,
      name: exchange.Name,
      operatingMIC: exchange.OperatingMIC,
      country: exchange.Country,
      currency: exchange.Currency,
      countryISO2: exchange.CountryISO2,
      countryISO3: exchange.CountryISO3,
      tradingHours: exchange.TradingHours ? {
        open: exchange.TradingHours.Open,
        close: exchange.TradingHours.Close,
        timezone: exchange.TradingHours.Timezone
      } : undefined,
      holidays: exchange.Holidays?.map(holiday => ({
        date: holiday.Date,
        name: holiday.Name
      }))
    }));
  } catch (error) {
    console.error('Error fetching exchanges:', error);
    throw error;
  }
};

export const getExchangeDetails = async (exchangeCode: string): Promise<Exchange> => {
  try {
    const response = await fetch(
      `${EODHD_BASE_URL}/exchange-details/${exchangeCode}?api_token=${EODHD_API_KEY}&fmt=json`
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch details for exchange ${exchangeCode}`);
    }

    const data: ExchangeResponse = await response.json();
    
    return {
      code: data.Code,
      name: data.Name,
      operatingMIC: data.OperatingMIC,
      country: data.Country,
      currency: data.Currency,
      countryISO2: data.CountryISO2,
      countryISO3: data.CountryISO3,
      tradingHours: data.TradingHours ? {
        open: data.TradingHours.Open,
        close: data.TradingHours.Close,
        timezone: data.TradingHours.Timezone
      } : undefined,
      holidays: data.Holidays?.map(holiday => ({
        date: holiday.Date,
        name: holiday.Name
      }))
    };
  } catch (error) {
    console.error(`Error fetching exchange details for ${exchangeCode}:`, error);
    throw error;
  }
};
